<template>
  <CModal :title="title" :color="color" :show.sync="showModal" class="basic-modal-color">
    <CForm id="guest_form" method="POST" enctype="multipart/form-data">
      <CInput hidden :lazy="false" :value.sync="$v.form.id.$model" name="id" id="id" />
      <CInput hidden :lazy="false" :value.sync="$v.form.event_id.$model" name="event_id" id="event_id-guest-modal" />
      <CRow>
        <CCol md="6">
          <CInput label="Nombre:" :lazy="false" :value.sync="$v.form.name.$model" :isValid="checkIfValid('name')"
            name="name" id="name" placeholder="Nombre" autocomplete="given-name"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
        <CCol md="6">
          <CInput label="Apellidos:" :lazy="false" :value.sync="$v.form.last_name.$model" name="last_name"
            id="last_name" placeholder="Apellidos" autocomplete="given-last_name"
            invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres." />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="7">
          <CInput label="Apodo:" :lazy="false" :value.sync="$v.form.nickname.$model" name="nickname" id="nickname"
            placeholder="Apodo" autocomplete="given-nickname" />
        </CCol>
        <CCol md="5">
          <CSelect label="Restricción Alimenticia:" :value.sync="$v.form.has_restriction.$model"
            :options="restrictionOptions" name="has_restriction" id="has_restriction" />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="6">
          <CInput label="N° Invitados:" :lazy="false" :value.sync="$v.form.tickets.$model" name="tickets" id="tickets"
            placeholder="" />
        </CCol>
        <CCol md="6">
          <CSelect label="Mesa:" :value.sync="$v.form.event_table_id.$model" :options="tablesOptions"
            name="event_table_id" id="event_table_id" />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="6">
          <CInput label="Whatsapp:" :lazy="false" :value.sync="$v.form.phone.$model" :isValid="checkIfValid('phone')"
            name="phone" id="phone" placeholder="000 000 00 00" autocomplete="given-phone" :invalidFeedback="contact_method === 'phone'
              ? 'Este campo es requerido y debe contener al menos 10 caracteres.'
              : 'Este campo debe tener mínimo 10 caracteres.'" />
        </CCol>
        <CCol md="6">
          <CInput label="Correo:" :lazy="false" :value.sync="$v.form.email.$model" name="email" id="email"
            :isValid="checkIfValid('email')" placeholder="correo@correo.com" />
        </CCol>
      </CRow>
      <CRow>
        <CCol md="12">
          <CTextarea label="Comentarios:" :lazy="false" :value.sync="$v.form.comments.$model" name="comments"
            type="text" id="comments" placeholder="Comentarios del invitado" autocomplete="given-comments" />
        </CCol>
      </CRow>
    </CForm>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="store" :color="color">Aceptar</CButton>
    </template>
  </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, requiredIf, minLength, helpers } from "vuelidate/lib/validators"
import store from '@/store';
import ws from '@/services/events_guests';
import ws_table from '@/services/events_tables';

const minLengthIfFilled = (min) =>
  helpers.withParams({ type: 'minLengthIfFilled', min }, (value) => {
    if (!helpers.req(value)) return true; // si está vacío, pasa
    return String(value).length >= min;
  });

export default {
  name: 'GuestModal',
  props: {
  },
  components: {
  },
  data() {
    return {
      showModal: false,
      title: "Nuevo Invitado",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      tablesOptions: [],
      restrictionOptions: [{ "label": "No", "value": "0" }, { "label": "Si", "value": 1 }],
      event_id: 0,
      contact_method: 'phone'
    }
  },
  mounted: async function () {
  },
  methods: {
    async storeModal(event_id, contact_method = '') {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Invitado';
      this.isEdit = false;
      this.submitted = false;
      this.contact_method = contact_method;

      this.form = {
        id: 0,
        name: '',
        last_name: '',
        nickname: '',
        phone: '',
        email: '',
        tickets: 1,
        event_table_id: 0,
        comments: "",
        has_restriction: 0,
      }
      this.form.event_id = event_id;

      let response_tables = await ws_table.get(event_id);
      if (response_tables.type == "success") {
        this.tablesOptions = await this.$parseSelectOptions(response_tables.data, "id", "name", [{ "label": "Sin Mesa", "value": "" }]);
        this.form.event_table_id = this.tablesOptions[0].value;
      }
    },
    async updateModal(item, contact_method = '') {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Invitado';
      this.isEdit = true;
      this.submitted = false;
      this.contact_method = contact_method;

      this.form = {
        id: item.id,
        event_id: item.event_id,
        name: item.name,
        last_name: item.last_name,
        nickname: item.nickname,
        phone: item.phone,
        email: item.email,
        tickets: item.tickets,
        event_table_id: item.event_table_id,
        comments: item.comments,
        has_restriction: item.has_restriction,
      };
      this.form.event_id = item.event_id;

      let response_tables = await ws_table.get(item.event_id);
      if (response_tables.type == "success") {
        this.tablesOptions = await this.$parseSelectOptions(response_tables.data, "id", "name", [{ "label": "Sin Mesa", "value": "" }]);
      }
    },
    async store() {
      this.$v.$touch();

      if (this.isValid) {
        this.loading();
        this.submitted = true;

        try {
          let form = document.getElementById("guest_form");
          let formData = new FormData(form);
          let response = "";
          if (this.form.id > 0) {
            response = await ws.update(formData);
          }
          else {
            response = await ws.store(formData);
          }

          this.showToast(response.type, response.message);
          if (response.type == "success") {
            this.$emit("refreshItems");
            this.closeModal();
          }
        } catch (error) {
          const fallbackMessage = "No fue posible guardar el invitado.";
          const message = error && error.message ? error.message : fallbackMessage;
          this.showToast("danger", message);
        } finally {
          this.loaded();
        }
      }
    },
    closeModal() {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm() {
      return {
        id: 0,
        event_id: 0,
        name: '',
        last_name: '',
        nickname: '',
        phone: '',
        email: '',
        tickets: 1,
        event_table_id: 0,
        comments: "",
        has_restriction: 0,
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) return null;

      // Si no es requerido, no lo forzamos como inválido
      const isRequired = this.$v.form[fieldName].$params?.required;
      if (!isRequired && !field.$model) return true;

      return !field.$invalid;
    },

    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  },
  computed: {
    formString() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$invalid },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {
      },
      event_id: {

      },
      name: {
        required,
        minLength: minLength(3)
      },
      last_name: {
      },
      nickname: {
      },
      phone: {
        required: requiredIf(function () {
          return this.contact_method === 'phone'
        }),
        minLengthIfFilled: minLengthIfFilled(10)
      },
      email: {        
      },
      tickets: {
      },
      event_table_id: {
      },
      comments: {

      },
      has_restriction: {

      },
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header {
  background-color: #668269 !important;
}
</style>